var exports = {
  "image": "xcc377c0b--eb07a8--image",
  "image--cover": "xcc377c0b--eb07a8--image--cover",
  "imageContainer": "xcc377c0b--eb07a8--imageContainer",
  "iconContainer": "xcc377c0b--eb07a8--iconContainer",
  "image--contain": "xcc377c0b--eb07a8--image--contain",
};

module.exports = exports;
